export default function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "shared.worker.js?v=7.47.5");
}
